import { ComponentProps } from 'react';
import { useFlag } from '@/features/unleash';

import useUser from '@/hooks/useUser';
import { CompanyNarratives } from './CompanyNarratives';

type CompanyNarrativesProps = ComponentProps<typeof CompanyNarratives>;

export const FlaggedCompanyNarratives = (props: CompanyNarrativesProps) => {
  const { data: user } = useUser();
  const { flagsReady, enabled, variant } = useFlag({
    name: 'mono-company-narratives',
  });

  if (!user.loggedIn && flagsReady && enabled && variant.name === 'variant') {
    return null;
  }

  if (!user.loggedIn && flagsReady && enabled && variant.name === 'control') {
    return <CompanyNarratives {...props} />;
  }

  // NOTE: If the user is authenticated always show the company narratives
  return <CompanyNarratives {...props} />;
};
